import { GA_MEASUREMENT_ID } from "../config/tracking";
import {
  clearAnalyticsCookies,
  startCookieSweep,
  stopCookieSweep,
} from "./clearAnalyticsCookies";

const disableKey = () => `ga-disable-${GA_MEASUREMENT_ID}`;

export const isPrerenderEnv = () =>
  typeof navigator !== "undefined" && navigator.webdriver === true;

const gtagScriptUrl = () =>
  `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;

const gtagScripts = () =>
  document.querySelectorAll(`script[src="${gtagScriptUrl()}"]`);

const removeGtagScripts = () => {
  if (typeof document === "undefined") return;
  gtagScripts().forEach((el) => el.remove());
};

const appendGtagScriptOnce = () => {
  if (gtagScripts().length) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = gtagScriptUrl();
  document.head.appendChild(script);
};

export const loadGoogleAnalytics = () => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (!GA_MEASUREMENT_ID) return;
  if (isPrerenderEnv()) return;
  if (window.__gaLoaded) return;

  stopCookieSweep("analytics");
  window[disableKey()] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    anonymize_ip: true,
    cookie_domain: window.location.hostname || "auto",
  });

  appendGtagScriptOnce();
  window.__gaLoaded = true;
};

export const trackGaPageView = (path) => {
  if (typeof window === "undefined") return;
  if (!window.__gaLoaded || typeof window.gtag !== "function") return;
  if (window[disableKey()]) return;

  window.gtag("event", "page_view", {
    page_path: path,
    page_title: document.title,
  });
};

export const disableGoogleAnalytics = () => {
  if (typeof window === "undefined") return;
  window[disableKey()] = true;
  window.__gaLoaded = false;
  removeGtagScripts();
  startCookieSweep("analytics", clearAnalyticsCookies);
};
